import './styles/main.scss'

import MainMenu from './scripts/main-menu'
import MainMenuDropdown from './scripts/main-menu-dropdown'
import './scripts/language-switcher'
import './scripts/panel'
import './scripts/popup'

const mainMenu = new MainMenu()
const mainMenuDropdown = new MainMenuDropdown()

const iframe = document.querySelectorAll('iframe.newsroom')

// if (iframe) {
//     iframe.forEach((element) => {
//         const headerHeight = document.querySelector('.site-header').offsetHeight
//         const footerHeight = document.querySelector('.site-footer').offsetHeight
//         const mainHeight = window.innerHeight - (headerHeight + footerHeight)
//         element.style.height = mainHeight + 'px'
//     })
// }
